import { isDesktopWidth } from '@/utils/desktopChrome';
import { rememberCatalogNavigation, catalogQueryPosition } from '@/utils/desktopCatalog';

export default ({ app }) => {
  const router = app.router;
  const originalScroll = router.options.scrollBehavior;

  router.beforeEach((to, from, next) => {
    rememberCatalogNavigation(to, from);
    next();
  });

  // Query-only catalog updates have no page transition; restore or reset immediately.
  router.options.scrollBehavior = function (to, from, savedPosition) {
    if (typeof window !== 'undefined' && isDesktopWidth(window.innerWidth)) {
      const queryPosition = catalogQueryPosition(to, from, savedPosition);
      if (queryPosition) return queryPosition;
    }
    return originalScroll.call(this, to, from, savedPosition);
  };
};
